import ErrorBoundary from "@/pages/error/errorBoundary/ErrorBoundary";
import { MainLayout, RootLayout } from "@/pages/layouts/index";
import NotFound from "@/pages/notFound/NotFound";
import { lazyRetry } from "@/services/system/importComponents";
import { Suspense } from "react";
import { createBrowserRouter, RouteObject, RouterProvider } from "react-router-dom";
import { propertiesRoutes as routes } from "../../app/routes";
import CustomSpinner from "../spinner/CustomSpinner";

const Properties = lazyRetry(() => import("@/pages/properties/Properties"));
const UnderConstruction = lazyRetry(() => import("@/pages/underConstruction/UnderConstruction"));
const LoanApp = lazyRetry(() => import("@/pages/loanApp/LoanApp"));
const LegalConsent = lazyRetry(() => import("@/pages/legalConsent/LegalConsent"));
const PaidLoans = lazyRetry(() => import("@/pages/paidLoans/PaidLoans"));
const ActiveLoans = lazyRetry(() => import("@/pages/activeLoans/ActiveLoans"));
const Payment = lazyRetry(() => import("@/pages/payment/Payment"));

const propertyRoutes = [
  {
    index: true,
    element: <UnderConstruction />,
  },
  {
    path: routes.loanApp.route,
    element: <LoanApp />,
  },
  {
    path: routes.consent.route,
    element: <LegalConsent />,
  },
  {
    path: routes.paidLoans.route,
    element: <PaidLoans />,
  },
  {
    path: routes.activeLoans.route,
    element: <ActiveLoans />,
  },
  {
    path: routes.payment.route,
    element: <Payment />,
  },
] as RouteObject[];

const mainRoutes = () =>
  [
    {
      path: routes.property.route,
      element: (
        <Suspense fallback={<CustomSpinner isFullScreen={true} />}>
          <ErrorBoundary>
            <RootLayout />
          </ErrorBoundary>
        </Suspense>
      ),
      children: [
        {
          index: true,
          element: <Properties title={routes.property.title} />,
        },
        {
          element: <MainLayout />,
          children: propertyRoutes,
        },
        {
          element: <MainLayout />,
          children: [
            {
              path: "*",
              element: <NotFound />,
            },
          ],
        },
      ],
    },
  ] as RouteObject[];

export const RouterBuilder = () => {
  const router = createBrowserRouter(mainRoutes(), {
    basename: import.meta.env.VITE_BASE_HREF,
  });

  return <RouterProvider router={router} />;
};
